import * as tslib_1 from "tslib";
import cx from 'classnames';
import { flow, noop } from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { parseXml } from "../../../utils/xml";
var SVG_OPEN_TAG_PATTERN = /<svg+[^>]*>/;
var SVG_CLOSE_TAG_PATTERN = /<\/svg>/;
var BASE_64_TAG_PATTERN = /data:image\/svg\+xml;base64,/;

var SvgIcon =
/** @class */
function (_super) {
  tslib_1.__extends(SvgIcon, _super);

  function SvgIcon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.xhr = null;
    _this.mount = false; // to prevent setSvg method from setting the state when component was unmounted

    _this.state = {
      hovered: false,
      svgTag: {},
      svgContentRaw: null
    };

    _this.loadSvgRaw = function (src) {
      var base64Matches = src.match(BASE_64_TAG_PATTERN);

      if (base64Matches) {
        var decodedSrc = atob(src.replace(base64Matches[0], ''));

        _this.onLoadSvg(decodedSrc);
      } else {
        _this.xhr = new XMLHttpRequest();

        _this.xhr.open('GET', src);

        _this.xhr.onload = function () {
          if (_this.xhr.status >= 200 && _this.xhr.status < 300) {
            _this.onLoadSvg(_this.xhr.responseText);
          } else {
            _this.props.onError("Could not donwnload SvgIcon from " + src);
          }
        };

        _this.xhr.send();
      }
    };

    _this.onLoadSvg = function (svgRaw) {
      var onLoad = _this.props.onLoad;

      _this.setSvg(svgRaw);

      onLoad && onLoad();
    };

    _this.setSvg = function (svgRaw) {
      _this.setSvgTag(svgRaw).then(function (svgTag) {
        var svgContentRaw = flow([_this.validateSvgFillColor, _this.cutSvgTag])(svgRaw);

        if (_this.mount) {
          _this.setState({
            svgTag: svgTag,
            svgContentRaw: svgContentRaw
          });
        }
      }).catch(function (error) {
        throw new Error(error);
      });
    };

    _this.setSvgTag = function (svgRaw) {
      return new Promise(function (resolve, reject) {
        var svgMatches = svgRaw.match(SVG_OPEN_TAG_PATTERN);

        if (svgMatches) {
          var openTag = svgMatches[0];
          parseXml(openTag + "</svg>", function (error, result) {
            error ? reject(error) : resolve(result);
          });
        }
      });
    };

    _this.validateSvgFillColor = function (svgRaw) {
      var color = _this.props.color;
      return color ? svgRaw.replace(/fill=[""'].+?[""']/g, '') : svgRaw;
    };

    _this.cutSvgTag = function (svgRaw) {
      var pattern = new RegExp(SVG_OPEN_TAG_PATTERN.source + "|" + SVG_CLOSE_TAG_PATTERN.source, 'g');
      return svgRaw.replace(pattern, '');
    };

    _this.handleMouseEnter = function (event) {
      if (!_this.props.disabled) {
        _this.setState({
          hovered: true
        });

        _this.props.onMouseEnter(event);
      }
    };

    _this.handleMouseLeave = function (event) {
      if (!_this.props.disabled) {
        _this.setState({
          hovered: false
        });

        _this.props.onMouseLeave(event);
      }
    };

    return _this;
  }

  SvgIcon.prototype.componentDidMount = function () {
    var _a = this.props,
        svgRaw = _a.svgRaw,
        src = _a.src;
    this.mount = true;

    if (svgRaw) {
      this.setSvg(svgRaw);
    } else if (src) {
      this.loadSvgRaw(src);
    }
  };

  SvgIcon.prototype.componentWillReceiveProps = function (nextProps) {
    var _a = this.props,
        src = _a.src,
        svgRaw = _a.svgRaw;

    if (svgRaw !== nextProps.svgRaw) {
      this.setSvg(nextProps.svgRaw);
    } else if (src !== nextProps.src) {
      this.loadSvgRaw(nextProps.src);
    }
  };

  SvgIcon.prototype.componentWillUnmount = function () {
    this.mount = false;

    if (this.xhr) {
      this.xhr.abort();
    }
  };

  SvgIcon.prototype.render = function () {
    var _a;

    var _b = this.props,
        style = _b.style,
        disabled = _b.disabled,
        className = _b.className,
        isActive = _b.isActive,
        color = _b.color,
        hoverColor = _b.hoverColor,
        src = _b.src,
        // eslint-disable-line no-unused-vars
    blockName = _b.blockName,
        otherProps = tslib_1.__rest(_b, ["style", "disabled", "className", "isActive", "color", "hoverColor", "src", "blockName"]);

    var _c = this.state,
        svgContentRaw = _c.svgContentRaw,
        hovered = _c.hovered,
        svgTag = _c.svgTag;
    return React.createElement("svg", tslib_1.__assign({}, svgTag.attributes, {
      className: cx(blockName, className, (_a = {}, _a[blockName + "--disabled"] = disabled, _a[blockName + "--active"] = isActive, _a[blockName + "--hovered"] = hovered, _a[className + "--disabled"] = className && disabled, _a[className + "--active"] = className && isActive, _a[className + "--hovered"] = className && hovered, _a)),
      style: tslib_1.__assign({
        fill: !disabled && (isActive || hovered) && hoverColor || color
      }, style)
    }, otherProps, {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      dangerouslySetInnerHTML: {
        __html: svgContentRaw
      }
    }));
  };

  SvgIcon.propTypes = {
    className: PropTypes.string,
    blockName: PropTypes.string,
    src: PropTypes.string,
    onLoad: PropTypes.func,
    // raw loaded svg by 'raw-loader'
    svgRaw: function svgRaw(props, propName, componentName) {
      if (!props.src && !props.svgRaw) {
        return new Error("Warning: One of props 'src' or 'svgRaw' was not specified in '" + componentName + "'.");
      } else if (props.svgRaw && typeof props.svgRaw !== 'string') {
        return new Error("Warning: Invalid prop 'svgRaw', expected 'string' in '" + componentName + "'.");
      }
    },

    /**
     * Add .nx-svg-icon--disabled and ${className}--disabled
     */
    disabled: PropTypes.bool,

    /**
     * Add .nx-svg-icon--active and ${className}--active
     */
    isActive: PropTypes.bool,

    /**
     * This is the svg color when the mouse hovers over the svg.
     */
    color: PropTypes.string,

    /**
     * Set fill for svg when mouse hovered
     */
    hoverColor: PropTypes.string,

    /**
     * Override the inline-styles of the root element.
     */
    style: PropTypes.object,

    /** Handlers */
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onError: PropTypes.func
  };
  SvgIcon.defaultProps = {
    blockName: 'nx-svg-icon',
    disabled: false,
    isActive: false,
    style: {},
    onMouseEnter: noop,
    onMouseLeave: noop,
    onError: noop
  };
  return SvgIcon;
}(React.PureComponent);

export default SvgIcon;

try {
  // @ts-ignore
  SvgIcon.__docgenInfo = {
    "description": "",
    "displayName": "SvgIcon",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}